export const groupInvoices = (rows) => {
  return rows.reduce((acc, row) => {
    const { invoiceStatus = 'GFE', invoiceId, dateofservice } = row;

    const updatedRow = {
      ...row,
      hasStrike: row?.status === 'cancelled'
    };

    if (!acc[invoiceStatus]) {
      acc[invoiceStatus] = {
        statusName: invoiceStatus,
        invoices: {}
      };
    }

    if (!acc[invoiceStatus].invoices[invoiceId]) {
      acc[invoiceStatus].invoices[invoiceId] = {
        dateofservice,
        rows: []
      };
    }

    acc[invoiceStatus].invoices[invoiceId].dateofservice = dateofservice;
    acc[invoiceStatus].invoices[invoiceId].rows.push(updatedRow);

    return acc;
  }, {});
};
